import React, { FunctionComponent } from 'react';
import { PortableText, PortableTextReactComponents } from '@portabletext/react';
import AboutUsHome from './AboutUsHome';
import DoubleFeaturedPages from './DoubleFeaturedPages';
import DoubleFeaturedArticles from './DoubleFeaturedArticles';
import NewsHome from './NewsHome';
import OneColumn from './OneColumn';
import TwoColumns from './TwoColumns';
import ContentGrid from './ContentGrid';
import FAQ from './FAQ';
import VideoCarousel from './VideoCarousel';
import ExtraContentVideos from './ExtraContentVideos';
import ExtraContentVideosList from './ExtraContentVideoList';
import RecipesList from '../RecipesList';
import InternalPageList from './InternalPageList';
import InternalPageStrip from './InternalPageStrip';
import Card from './Card';
import CardPopUp from './CardPopUp';
import VideoCard from './VideoCard';
import SocialLink from '../SocialLink';
import FooterSection from './FooterSection'
import InternalLink from '../InternalLink';
import ExternalContent from './ExternalContent';
import ExtraNews from './ExtraNews';
import ExternalLinks from './ExternalLinks';
import ProductionResearchDatabase from './ProductionResearchDatabase';
import ContactComponent from './ContactComponent';
import { HomeFilters } from '../HomeFilters';
import ExtraContentRecipesList from './ExtraContentRecipesList';

import './styles.scss';
import ExtraContentRecipes from './ExtraContentRecipes';

type PageContentComponentProps = {
  content: any;
}

const components: Partial<PortableTextReactComponents> = {
  types: {
    // Home Components
    aboutUsHome: ({ value }) => <AboutUsHome data={value} />,
    doubleFeaturedPages: ({ value }) => <DoubleFeaturedPages data={value} />,
    doubleFeaturedArticles: ({ value }) => <DoubleFeaturedArticles data={value} />,
    newsHome: ({ value }) => <NewsHome data={value} />,

    // General Components
    oneColumn: ({ value }) => <OneColumn data={value} />,
    twoColumns: ({ value }) => <TwoColumns data={value} />,
    contentGrid: ({ value }) => <ContentGrid data={value} />,
    faq: ({ value }) => <FAQ data={value} />,
    videoCarousel: ({ value }) => <VideoCarousel data={value} />,
    extraContentVideos: ({ value }) => <ExtraContentVideos data={value} />,
    extraContentVideosList: ({ value }) => <ExtraContentVideosList data={value} />,
    extraContentRecipes: ({ value }) => <ExtraContentRecipes data={value} />,
    extraContentRecipesList: ({ value }) => <ExtraContentRecipesList data={value} />,
    extraNews: ({ value }) => <ExtraNews data={value} />,
    internalPageList: ({ value }) => <InternalPageList data={value} />,
    internalPageStrip: ({ value }) => <InternalPageStrip data={value} />,
    externalContent: ({ value }) => <ExternalContent data={value} />,
    externalLinks: ({ value }) => <ExternalLinks data={value} />,
    productionResearchDatabase: ({ value }) => <ProductionResearchDatabase data={value} />,
    contactForm: ({ value }) => <ContactComponent data={value} />,
    filtersHome: ({ value }) => <HomeFilters filter={value.filter} />,

    // Sub Components
    card: ({ value }) => <Card data={value} />,
    videoCard: ({ value }) => <VideoCard data={value} />,
    cardPopUp: ({ value }) => <CardPopUp data={value} />,
    socialLink: ({ value }) => <SocialLink data={value} />,

    footerSection: ({ value }) => <FooterSection data={value} />,
  },
  marks: {
    linkInternal: ({ children, value }) => {
      return <InternalLink reference={value.reference}>{children}</InternalLink>;
    },
  }
}

const PageContentComponent: FunctionComponent<PageContentComponentProps> = ({ content }) => {
  return (
    <PortableText
      value={content}
      components={components}
    />
  );
}

export default PageContentComponent;
